<template>
  <InRightStatistic></InRightStatistic>
</template>

<script>
import InRightStatistic from "./InRightStatistic";
// import InRightWilayah from "./InRightWilayah";
// import InRightSekolahPopuler from "./InRightSekolahPopuler";
// import InRightNoRekening from "./InRightNoRekening";

export default {
  components: {
    InRightStatistic,
    // InRightWilayah,
    // InRightSekolahPopuler,
    // InRightNoRekening,
  },
};
</script>




